import {rootState} from '@mintdata-wsp/common/state/RootState';
import {
    PropertiesVisiblePopover,
    SurfacePropertiesPanelState
} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceEditorState';
import {PropertyPanelTabId} from '@mintdata/mint-kit/api/properties/PropertyPanelTabId';
import {action} from 'mobx';
import {PropertyEditorViewState} from '@mintdata/mint-kit/api/properties/PropertyEditorViewState';
import {EditorId} from '@mintdata/mint-kit/api/properties/PropertyEditor';

export class SurfacePropertiesPanelController
{
    public propertiesVisiblePopover():PropertiesVisiblePopover
    {
        return this._getState().propertiesVisiblePopover;
    }

    public isRepeaterPropertiesVisible():boolean
    {
        return this._getState().propertiesVisiblePopover === PropertiesVisiblePopover.Repeater;
    }

    public isLoaderPropertiesVisible():boolean
    {
        return this._getState().propertiesVisiblePopover === PropertiesVisiblePopover.Loader;
    }

    public isEventsPropertiesVisible():boolean
    {
        return this._getState().propertiesVisiblePopover === PropertiesVisiblePopover.Events;
    }

    @action.bound
    public setPropertiesPopover(popover:PropertiesVisiblePopover):void
    {
        this._getState().propertiesVisiblePopover = popover;
    }

    @action.bound
    public toggleRepeaterPropertiesPopover():void
    {
        this.setPropertiesPopover(this.isRepeaterPropertiesVisible() ? PropertiesVisiblePopover.None : PropertiesVisiblePopover.Repeater);
    }

    @action.bound
    public toggleLoaderPropertiesPopover():void
    {
        this.setPropertiesPopover(this.isLoaderPropertiesVisible() ? PropertiesVisiblePopover.None : PropertiesVisiblePopover.Loader);
    }

    @action.bound
    public toggleEventsPropertiesPopover():void
    {
        this.setPropertiesPopover(this.isEventsPropertiesVisible() ? PropertiesVisiblePopover.None : PropertiesVisiblePopover.Events);
    }

    @action.bound
    public setSelectedTabId(selectedTabId:PropertyPanelTabId):void
    {
        this._getState().selectedTabId = selectedTabId;
    }

    public getSelectedTabId():PropertyPanelTabId
    {
        return this._getState().selectedTabId;
    }

    @action.bound
    public setEditorViewState(editorId:EditorId, state:PropertyEditorViewState):void
    {
        this._getState().propertyEditorViewStates.set(editorId, state);
    }

    public getEditorViewState(editorId:EditorId):PropertyEditorViewState
    {
        if( this._getState().propertyEditorViewStates.has(editorId) )
            return this._getState().propertyEditorViewStates.get(editorId);
    }

    private _getState():SurfacePropertiesPanelState
    {
        return rootState.ui.visualDesigner.surfaceEditor.propertiesPanel;
    }
}
